import BusSocket from "~/socket/bus.js";

export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    const busSocket = new BusSocket();
    window.busSocket = busSocket;

    // Inject busSocket into nuxtApp
    return {
      provide: {
        busSocket,
      },
    };
  }
});
